export const PASSWORD_REGEX = '^(?=.*\\d).{7,}$';
